import React from 'react';
import { RenderPage } from '@/src/render';
import { store } from '@/src/store/configure';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { TechnicalPieChart } from './components/TechnicalPieChart';

export const TechnicalGraph = () => {
  return <TechnicalPieChart />;
};

RenderPage(
  'csr-stock-technical-graph-section',
  <Provider store={store}>
    <BrowserRouter>
      <TechnicalGraph />
    </BrowserRouter>
  </Provider>,
);
